export const APIdata = {
    "persondata": {
        "aboutus": [{
            "imageLink": "images/profile.jpg",
            "Name": "Shivesh Gupta",
            "Email": "guptashiv84@gmail.com",
            "Phonenumber": "8968330448",
            "Personallinks":[
                "Guptashiv84@gmail.com",
                "https://www.linkedin.com/in/shivesh-gupta-86712b178/",
                "https://github.com/shivesh947",
				"8968330448"
            ],
            "links": [{
                    "icon": "url",
                    "type": "Git",
                    "url": "https://github.com/shivesh947"
                },
                {
                    "icon": "url",
                    "type": "Linkedin",
                    "url": "https://www.linkedin.com/in/shivesh-gupta-86712b178/"
                }
            ],
            "developertype": "Full Stack Developer",
            "heading": "Great things are done by a series of small things brought together.",
            "description": "I love building UI/UX design experiences that improve user's everyday life + I like to design Front end of website and Development of beckend. I am always hungry for new challenges and innovations. Any spare time I have to work on side projects to further my skills so that I can apply these to real projects."
        }],
        "skill": [{
            "name": [
                "HTML",
                "CSS",
                "JAVASCRIPT",
                "React",
                "Tailwind",
				"Redux / Uni store",
                "Chakra UI",
                "UI Design",
				"React Native",
                "Nodejs",
                "PHP",
                "Mysql"
            ],
            "percentage": [
                "100",
                "95",
                "90",
                "90",
                "90",
                "80",
                "80",
                "90",
                "60",
                "65",
                "65",
                "65"
            ]
        }],
        "projects": [{
                "Name": "Css Styler",
                "livelink": "https://shivesh947.github.io/css_styler/button%20maker%20done/temp.html",
                "gitlink": "https://github.com/shivesh947/css_styler",
                "imageLink": "images/projecticon/logo1.png",
                "shortdescription": "In this web application you create your own designer buttons, form , div, etc in one roof"
            },
            {
                "Name": "Car Racing",
                "livelink": "https://shivesh947.github.io/Arcade_Car_Game/",
                "gitlink": "https://github.com/shivesh947/Arcade_Car_Game",
                "imageLink": "images/projecticon/logo2.png",
                "shortdescription": "Arcade Car racing game in pure javascript"
            },
            {
                "Name": "Colorama",
                "livelink": "https://shivesh947.github.io/colorama/color.html",
                "gitlink": "https://github.com/shivesh947/colorama",
                "imageLink": "images/projecticon/logo3.png",
                "shortdescription": "This application help to picking color for website and making gradient easily. "
            },
            {
                "Name": "News of India",
                "livelink": "https://shivesh947.github.io/Newswebsite/",
                "gitlink": "https://github.com/shivesh947/Newswebsite",
                "imageLink": "images/projecticon/logo4.png",
                "shortdescription": "News website using react please click home inside the live link"
            },
            {
                "Name": "TIC_TAC_TOE",
                "livelink": "https://kidoworld.000webhostapp.com/tic-tac-toe/index.html",
                "gitlink": "https://github.com/shivesh947/TIC_TAC_TOE",
                "imageLink": "images/projecticon/logo5.png",
                "shortdescription": "It a progressive web application making by using javascript "
            },
            {
                "Name": "MOMCQT",
                "livelink": "",
                "gitlink": "https://github.com/shivesh947/MOMCQT",
                "imageLink": "images/projecticon/logo6.png",
                "shortdescription": "MOMCQT Stand for Make Own Multiple Choice Question Test. In this Application You can easily generate your own mock test. "
            },
            {
                "Name": "Snake Game",
                "livelink": "https://shivesh947.github.io/Snake_game/index.html",
                "gitlink": "https://github.com/shivesh947/Snake_game/",
                "imageLink": "images/projecticon/logo7.png",
                "shortdescription": "Arcade snake game using javascript and canvas framework"
            },
            {
                "Name": "Train Enquiry System",
                "livelink": "https://kidoworld.000webhostapp.com/Train%20Enquiry%20System/railway.php",
                "gitlink": "https://github.com/shivesh947/Train-Enquiry-System",
                "imageLink": "images/projecticon/logo8.png",
                "shortdescription": "Find list of trains and details with the help of Location and train name easily"
            },
            {
                "Name": "Sarthi",
                "livelink": "https://creepiest-men.000webhostapp.com/project%20online/index.php",
                "gitlink": "",
                "imageLink": "images/projecticon/logo9.png",
                "shortdescription": "This PWA application send messages to family member and near policestation"
            },
            {
                "Name": "Ticket generater",
                "livelink": "https://kidoworld.000webhostapp.com/ticket/ticketbook.html",
                "gitlink": "https://github.com/shivesh947/Ticket_generater_QR",
                "imageLink": "images/projecticon/logo10.png",
                "shortdescription": "Its a php application help for generating tickets with the help of qr code"
            },
            {
                "Name": "Poker Game",
                "livelink": "",
                "gitlink": "https://github.com/shivesh947/Poker",
                "imageLink": "images/projecticon/logo11.png",
                "shortdescription": "Poker game made by Python with local storage "
            },
            {
                "Name": "Handicraft selling",
                "livelink": "https://kidoworld.000webhostapp.com/website/Categories/Categories.php",
                "gitlink": "https://github.com/shivesh947/Handicraft_selling",
                "imageLink": "images/projecticon/logo12.png",
                "shortdescription": "Handicraft selling website show front end only "
            }
        ],
        "mockups":[
				{
					"name":"food",
					"imagelink":"images/mockups/web1.png"
				},
				{
					"name":"dance ",
					"imagelink":"images/mockups/web11.png"
				},
				{
					"name":"train ",
					"imagelink":"images/mockups/web10.png"
				},
				{
					"name":"glassMorphisum ",
					"imagelink":"images/mockups/web13.png"
				},
				{
					"name":"style ",
					"imagelink":"images/mockups/web12.png"
				},
				{
					"name":"glassMorphisum ",
					"imagelink":"images/mockups/web15.png"
				},
				{
					"name":"space ",
					"imagelink":"images/mockups/web2.png"
				},
				{
					"name":"body",
					"imagelink":"images/mockups/web3.png"
				},
				{
					"name":"shop ",
					"imagelink":"images/mockups/web4.png"
				},
				{
					"name":"shop ",
					"imagelink":"images/mockups/web5.png"
				},
				{
					"name":"shop ",
					"imagelink":"images/mockups/web6.png"
				},
				{
					"name":"shop ",
					"imagelink":"images/mockups/web7.png"
				},
				{
					"name":"shop ",
					"imagelink":"images/mockups/web8.png"
				}
            ],
        "education": [{
            "imageLink": "",
            "name": "jAVA",
            "link": "",
            "year": "2012-2018",
            "month": "feb-june"
        }]
    }

}

